import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";

export function shownResult(
  shown: string,
  reply: string,
  ignored: readonly string[] = [],
): HandlerOutcome {
  return {
    ok: true,
    message: withIgnored(`${shown}. ${replyInOneSentence(reply)} ${ONLY_KORTET}`, ignored),
  };
}

export function awaitingResult(
  shown: string,
  waits: string,
  reply: string,
  ignored: readonly string[] = [],
): HandlerOutcome {
  return {
    ok: true,
    message: withIgnored(
      `${shown}. ${waits}. ${replyInOneSentence(reply)} ${ONLY_KORTET}`,
      ignored,
    ),
  };
}

export function choiceResult(
  choice: { kind: "asks" | "finding" | "failed"; step: string },
  lead: string,
  keepOut: string,
  ignored: readonly string[] = [],
  notInText: string = `the ${choice.step}`,
): HandlerOutcome {
  const { step } = choice;
  const asks =
    choice.kind === "asks"
      ? `The card asks the advisor which ${step}; nothing is shown yet. Say in one sentence ` +
        "that the card asks."
      : choice.kind === "failed"
        ? `The card could not read ${UNREAD[step] ?? `the ${step}`} and says so; nothing is ` +
          "shown yet. Say in one sentence that the card could not read them."
        : `The card is still finding the ${step}, and asks the advisor which one unless exactly ` +
          "one matches; nothing is shown yet. Say in one sentence that the card is open.";
  return {
    ok: true,
    message: withIgnored(
      `${lead}. ${asks} Do not ask for ${notInText} in text, and ${keepOut}. ${ONLY_KORTET}`,
      ignored,
    ),
  };
}

export function handedOverResult(to: string, ignored: readonly string[] = []): HandlerOutcome {
  return {
    ok: true,
    message: withIgnored(
      `Handed over to ${to}. Reply in one short sentence. ${NO_VIEW_NAMES}`,
      ignored,
    ),
  };
}

export function clientIdTakenAsQuery(
  shown: string,
  { clientQuery }: { clientQuery: string | null },
  notAnId: string | undefined,
  asks: string,
): string {
  if (notAnId === undefined) return shown;
  return (
    `${shown}. client_id "${notAnId}" is not a client id, so the card searches with ` +
    `client_query "${clientQuery ?? notAnId}" instead: ${asks}`
  );
}

export function searchedInstead(
  shown: string,
  { clientQuery }: { clientQuery: string | null },
  notAnId: string | undefined,
): string {
  if (notAnId === undefined) return shown;
  return (
    `${shown}. client_id "${notAnId}" is not a client id, so the card searched with ` +
    `client_query "${clientQuery ?? notAnId}" instead`
  );
}

const UNREAD: Record<string, string> = {
  client: "the advisor's clients",
  portfolio: "the client's portfolios",
};

const NO_VIEW_NAMES = "Never name a view or page.";

const ONLY_KORTET = 'Refer to the card only as "kortet", and never name a view or page.';

function replyInOneSentence(reply: string): string {
  return `Reply in one short sentence that ${reply}.`;
}

function withIgnored(message: string, ignored: readonly string[]): string {
  return ignored.length === 0 ? message : `${message}\nignored: ${ignored.join(", ")}`;
}
